
import createIconComponent from './utils/createIconComponent';
import React from 'react';
var IconArrowButtonRight2 = createIconComponent({ fillContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M21.058 10.289L5.014.564a2 2 0 00-3.036 1.711v19.45a2 2 0 003.037 1.711l16.043-9.725a2 2 0 000-3.422z' })
  ), lightContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M3.99 23.225c-.4 0-.777-.156-1.06-.438a1.487 1.487 0 01-.44-1.06V2.273A1.496 1.496 0 013.992.775c.271 0 .539.075.773.217l16.069 9.725a1.49 1.49 0 01.68 1.643 1.491 1.491 0 01-.681.925L4.766 23.008a1.499 1.499 0 01-.774.216l-.002.001zm.001-21.451a.497.497 0 00-.501.5v19.452a.5.5 0 00.758.427l16.069-9.725a.496.496 0 00.169-.686.512.512 0 00-.17-.17L4.248 1.846a.499.499 0 00-.257-.072z' })
  ), regularContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M3.501 23.25a1.508 1.508 0 01-1.5-1.475V2.236c.004-.265.074-.518.201-.738A1.49 1.49 0 013.503.747c.261 0 .52.07.748.202l17.242 9.759a1.482 1.482 0 01.7 1.695c-.108.38-.358.695-.703.887L4.245 23.052a1.502 1.502 0 01-.719.198H3.501zm0-1.488l17.227-9.763-17.227-9.75v19.513zm17.254-9.778z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconArrowButtonRight2.displayName = 'IconArrowButtonRight2';
export default IconArrowButtonRight2;